// extracted by mini-css-extract-plugin
export default {"cls1":"AwCaTTWCQiWGbSGnmTX7","cls2":"VK381YGvGNwXLP_J7nRz AwCaTTWCQiWGbSGnmTX7"};